import React from "react";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import Layout from "../../layout/realestateagent/Layout";
import HousingPlot from "../../layout/realestateagent/HousingPost/HousingPlot";
const HousePost = () => {
  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        <div>
          <ProjectBanner
            title="House Post"
            imageUrl="https://via.placeholder.com/1200x300"
          />
        </div>
        <HousingPlot />
      </Layout>
    </div>
  );
};

export default HousePost;

